import { EnvironmentName } from "./environment.interface";

export function resolveWhitelabelEnvironment(
  bundleId: string
): EnvironmentName {
  if (bundleId === "nl.energyplatform") return "energyplatform";

  if (bundleId === "app.citychallenge") return "intractive";
  if (bundleId === "app.energywalks") return "energyplatform";

  return "intractive";
}
